import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isDefined } from 'common';

interface Props {
  organizationIds: string[];
}

export function OrganizationLabel(props: Props) {
  const { organizationIds } = props;
  const {
    data: organizationNames,
    isPending,
    isError,
  } = useQuery({
    ...getQueryProps(api.client.Organization, 'findAll'),
    select: (organizations) =>
      organizations
        /**
         * FIXME, this is inefficient and should be replaced with an API endpoint that accepts multiple organization IDs
         */
        .filter((organization) => organizationIds.includes(organization.id))
        .map((organization) => organization.name)
        .sort((name1, name2) => name1.localeCompare(name2)),
  });

  let label: string;
  if (isPending) {
    label = 'Loading';
  } else if (isError) {
    label = 'Error';
  } else if (isDefined(organizationNames)) {
    label = organizationNames.join(', ');
  } else {
    label = 'No organizations found';
  }

  return <span>{label}</span>;
}

export default OrganizationLabel;
